import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { MatDialog } from '@angular/material/dialog'
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component'

import { TranslatePipe } from '@ngx-translate/core'
import { MatDialogModule } from '@angular/material/dialog'
import { HelperService } from '../../services/helper.service'

@Component({
  selector: 'app-attachments',
  templateUrl: './attachments.component.html',
  styleUrls: ['./attachments.component.scss'],
  standalone: true,
  imports: [TranslatePipe, MatDialogModule]
})
export class AttachmentsComponent implements OnInit {
  @Input() inputFileId!: string
  @Input() fileList: any[] = []
  @Input() oneFile = false
  @Input() isImage = false
  @Output() changeFiles: EventEmitter<any> = new EventEmitter(true)
  @Input() showMode: boolean = false
  currentLanguage = localStorage.getItem('lang')

  fileName = ''

  file!: any
  maxFileSize = 50 * 1024 * 1024 // file size in 50 MB
  @Input() acceptFiles = '.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.pdf,.PDF,.docx'
  hasFileToUpload = false
  isSubmitted = false
  hideFileDesc = false
  displayedFileName = ''

  constructor(
    private translate: TranslateService,
    private dialog: MatDialog,
    private helper: HelperService
  ) {}

  ngOnInit(): void {
    this.getAppLanguage()
  }

  getAppLanguage() {
    this.translate.onLangChange.subscribe(
      (lang) => (this.currentLanguage = lang.lang)
    )
  }

  remove(idx: number) {
    this.fileList = this.fileList.filter((file, index) => index !== idx)
    this.emitFileList()
  }

  download(idx: number) {
    const item = this.fileList[idx]

    // A freshly-selected, not-yet-uploaded file is a browser File: download it locally.
    if (item instanceof File) {
      this.helper.createBlob(
        item,
        item.name,
        item.type || 'application/octet-stream'
      )
      return
    }

    // Otherwise it's a stored reference (full blob URI). The container is now private, so
    // stream it through the authorized backend endpoint instead of linking to the URL.
    this.helper.downloadAttachment(typeof item === 'string' ? item : item.url)
  }

  emitFileList() {
    this.changeFiles.emit(this.fileList)
  }
  beforeUpload = (event: any): boolean => {
    const input = event.target as HTMLInputElement
    const files = Array.from(input.files ?? []) as File[]

    if (!files.length) return false

    const allowedExtensions = ['.jpg', '.jpeg', '.png', '.pdf', '.docx']

    for (const file of files) {
      const fileName = file.name.toLowerCase()
      const fileExtension = fileName.substring(fileName.lastIndexOf('.'))

      if (!allowedExtensions.includes(fileExtension)) {
        this.fileTypeAlert()
        event.target.value = null
        return false
      }

      if (file.size > this.maxFileSize) {
        this.maxFileAlert()
        event.target.value = null
        return false
      }
    }

    //aHandle single or multiple
    if (this.oneFile) {
      this.fileList = [files[0]]
    } else {
      this.fileList = [...this.fileList, ...files]
    }

    this.changeFiles.emit(this.fileList)
    event.target.value = null // reset input
    return false
  }

  maxFileAlert() {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'Common-Msg.Invalid-File',
          message: 'Common-Msg.Max-File-Size',
          subMessage: 'Common-Msg.Max-File-Size-Text',
          image: 'warnning.svg',
          secondaryTitle: 'Actions-List.Ok',
          // primaryBtnTitle: 'Actions-List.Yes',
          isDelete: false
        }
      })
      .afterClosed()
      .subscribe(() => {})
  }

  triggerInput() {
    const input = document.getElementById(this.inputFileId)
    if (input) {
      input.click()
    }
  }

  fileTypeAlert() {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'Common-Msg.Invalid-File',
          message: 'Common-Msg.Invalid-File-Type',
          subMessage: 'Common-Msg.Please-Upload-Valid-File',
          image: 'warnning.svg',
          secondaryTitle: 'Actions-List.Ok',
          // primaryBtnTitle: 'Actions-List.Yes',
          isDelete: false
        }
      })
      .afterClosed()
      .subscribe(() => {})
  }
}
